var render = function render(){var _vm=this,_c=_vm._self._c;return _c('helper-message',{scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('span',[_vm._v("Copiar al portapapeles")])]},proxy:true}])},[_c('v-icon',_vm._b({attrs:{"size":_vm.size,"color":_vm.color,"disabled":_vm.disabled},on:{"click":_vm.copyText}},'v-icon',_vm.computedSizeProps,false),[_vm._v(" mdi-content-copy ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }